<p class="action-buttons" fxLayout="row" fxLayoutAlign="end">
    <button mat-raised-button color="primary" (click)="addCategory()" aria-label="Add New Category">
        <mat-icon>add</mat-icon>
        <span>Add New Category</span>
    </button>
</p>
<mat-card class="mat-elevation-z3">
    <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" #table>
            <!-- Name Column -->
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let category">{{ category.name }}</td>
            </ng-container>

            <!-- Active Column -->
            <ng-container matColumnDef="Active">
                <th mat-header-cell *matHeaderCellDef style="text-align: center; width: 10%">Active</th>
                <td mat-cell *matCellDef="let category" style="text-align: center">
                    <mat-checkbox [checked]="category.active" aria-label="Active" disabled></mat-checkbox>
                </td>
            </ng-container>

            <!-- DateCreated Column -->
            <ng-container matColumnDef="DateCreated">
                <th mat-header-cell *matHeaderCellDef style="width: 20%">DateCreated</th>
                <td mat-cell *matCellDef="let category">{{ category.dateCreated | date: 'short' }}</td>
            </ng-container>

            <!-- DateUpdated Column -->
            <ng-container matColumnDef="DateUpdated">
                <th mat-header-cell *matHeaderCellDef style="width: 20%">DateUpdated</th>
                <td mat-cell *matCellDef="let category">{{ category.dateUpdated | date: 'short' }}</td>
            </ng-container>

            <!-- UpdatedBySapid Column -->
            <ng-container matColumnDef="UpdatedBySapid">
                <th mat-header-cell *matHeaderCellDef style="width: 15%">UpdatedBySapid</th>
                <td mat-cell *matCellDef="let category">{{ category.updatedBySapid }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef style="width: 120px"></th>
                <td mat-cell *matCellDef="let category" style="text-align: center">
                    <button mat-flat-button color="primary" (click)="editCategory(category)">Edit</button>
                    <button mat-flat-button color="warn" (click)="deleteCategory(category)">Delete</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns" [class.evenRow]="even"></tr>
        </table>
    </div>
</mat-card>
